import { render, staticRenderFns } from "./HeartysanModule.vue?vue&type=template&id=be4bd492"
import script from "./HeartysanModule.vue?vue&type=script&lang=js"
export * from "./HeartysanModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports